import type { DailyTacticalReadiness } from '../../services/operationsApi';

export default function Atu2ReadinessDetails({ readiness }: Props) {
  const evidenceRows = readiness.evidence_completeness || [];
  return (
    <section className="atu2-panel">
      <div className="atu2-section-head">
        <div>
          <span className="atu2-kicker">시작 전 점검</span>
          <h2>무엇이 아직 막고 있나</h2>
        </div>
        <p>blocker는 공식 관찰 시작을 막는 조건입니다.</p>
      </div>
      <div className="atu2-detail-grid">
        <div className="atu2-detail-box">
          <strong>현재 막는 조건</strong>
          <ul>
            {readiness.blockers.length > 0
              ? readiness.blockers.map((item) => {
                const info = blockerText(item);
                return (
                  <li key={item}>
                    <span>{info.title}</span>
                    <code>{item}</code>
                    <small>{info.detail}</small>
                  </li>
                );
              })
              : <li>막는 조건 없음</li>}
          </ul>
        </div>
        <div className="atu2-detail-box">
          <strong>마감 위반</strong>
          <p>{deadlineText(readiness)}</p>
          <code>deadline_audit</code>
        </div>
      </div>
      <div className="atu2-evidence-list">
        {evidenceRows.length > 0
          ? evidenceRows.slice(0, 3).map((row) => <EvidenceRow row={row} key={row.run_id} />)
          : <p>아직 점검할 근거 묶음이 없습니다.</p>}
      </div>
    </section>
  );
}

function EvidenceRow({ row }: { row: NonNullable<DailyTacticalReadiness['evidence_completeness']>[number] }) {
  const missing = row.missing_required_source_types.join(', ') || '없음';
  const plumbing = row.cohort_id.includes('PLUMBING');
  const stateClass = row.complete ? ' complete' : plumbing ? ' expected-gap' : '';
  return (
    <article className={`atu2-evidence-row${stateClass}`}>
      <div>
        <strong>{row.trading_date}</strong>
        <code>{row.cohort_id}</code>
      </div>
      <span>{row.complete ? '완성' : plumbing ? '배관 테스트 누락' : '누락 있음'}</span>
      <p>
        저장됨: {row.source_types.join(', ')} · 누락: {missing}
        {plumbing && !row.complete && ' · 공식 관찰 판정에는 쓰지 않음'}
      </p>
    </article>
  );
}

function deadlineText(readiness: DailyTacticalReadiness) {
  const audit = readiness.deadline_audit;
  if (!audit) return '마감 위반 점검 데이터 없음';
  return `${audit.checked_run_count}건 점검 · 위반 ${audit.late_deviation_count}건`;
}

function blockerText(code: string) {
  if (code === 'market_payload_coverage_incomplete') {
    return {
      title: '시장 가격 근거가 아직 부족함',
      detail: '저장된 MARKET 데이터가 open/high/low/next open을 제공해야 가상 진입·청산을 검증할 수 있습니다.',
    };
  }
  return {
    title: '시작 전 조건 미충족',
    detail: '공식 관찰을 시작하기 전에 해소해야 하는 시스템 조건입니다.',
  };
}

type Props = {
  readiness: DailyTacticalReadiness;
};
